import { IconPerfil } from "./icones-perfis";

export type ProfileItem = {
  perfil: string;
  nome: string;
  descricao: string;
  icone: IconPerfil;
  criterios?: string[];
};

export const perfis: ProfileItem[] = [
  {
    perfil: "condutor",
    nome: "Perfil do Condutor",
    descricao:
      "Para cidadãos habilitados para condução de veículos automotores no estado.",
    icone: "icon-condutor",
    criterios: [
      "Possuir CNH ativa registrada no banco do Departamento Estadual de Trânsito do Piauí.",
      "Estar vinculado a um CPF válido e único (mesmo do cadastro no Gov.PI Cidadão).",
      "Pode possuir veículos registrados em seu nome (não obrigatório).",
    ],
  },
  {
    perfil: "empreendedor",
    nome: "Perfil do Empreendedor",
    descricao:
      "Para cidadãos que possuem atividades empresariais ou negócios registrados.",
    icone: "icon-empreendedor",
    criterios: ["Possuir CNPJ ativo vinculado ao CPF autenticado."],
  },
  {
    perfil: "produtor-rural",
    nome: "Perfil do Produtor Rural",
    descricao:
      "Para cidadãos com atividades ou propriedades rurais registradas.",
    icone: "icon-produtor-rural",
    criterios: [
      "Possuir cadastro rural ativo vinculado ao CPF/CNPJ.",
      "Ter propriedade rural ou vínculo produtivo registrado.",
    ],
  },
  {
    perfil: "aluno",
    nome: "Perfil do Aluno da Rede Estadual (ou Responsável)",
    descricao:
      "Para estudantes matriculados na rede pública estadual ou seus responsáveis.",
    icone: "icon-aluno",
    criterios: [
      "Cadastro ativo no SIGE/SEDUC vinculado ao CPF autenticado.",
      "6-15 anos: ensino regular (baseado na matrícula).",
      "16 anos: ensino médio ou técnico (baseado na matrícula).",
      "18 anos: ensino superior (UESPI).",
      "PROAJA (Alfabetização de Adultos).",
      "EJA.",
    ],
  },
  {
    perfil: "saude-publica",
    nome: "Perfil do Usuário da Saúde Pública",
    descricao: "Para cidadãos que utilizam a rede estadual de saúde pública.",
    icone: "icon-saude-publica",
    criterios: [
      "Cadastro ativo no SUS vinculado ao CPF.",
      "Possuir Cartão Nacional de Saúde válido.",
    ],
  },
  {
    perfil: "proprietario-imovel",
    nome: "Perfil do Proprietário de Imóvel",
    descricao:
      "Para cidadãos que possuem imóveis urbanos ou rurais registrados.",
    icone: "icon-proprietario-imovel",
    criterios: ["Possuir imóvel urbano ou rural vinculado ao CPF/CNPJ."],
  },
  {
    perfil: "turista",
    nome: "Perfil do Turista / Visitante",
    descricao:
      "Para pessoas que utilizam serviços do estado sem residir permanentemente nele.",
    icone: "icon-turista",
    criterios: [
      "Pessoas que utilizam serviços do estado sem ser residente permanente.",
    ],
  },
  {
    perfil: "beneficiario-programas-sociais",
    nome: "Perfil do Beneficiário de Programas Sociais",
    descricao:
      "Para cidadãos inscritos e elegíveis a programas sociais do estado.",
    icone: "icon-beneficiario-programas-sociais",
    criterios: [
      "Cadastro ativo no CadÚnico vinculado ao CPF.",
      "Elegibilidade em programas sociais estaduais.",
    ],
  },
  {
    perfil: "beneficiario-carteiras",
    nome: "Perfil de Beneficiário de Carteiras, Passes Livres e Benefícios",
    descricao: "Para cidadãos que possuem benefícios concedidos pelo estado.",
    icone: "icon-beneficiario-carteiras",
    criterios: [
      "Possuir benefício ativo concedido pelo Estado.",
      "Cadastro validado no sistema do programa específico.",
    ],
  },
  {
    perfil: "cidadao",
    nome: "Perfil do Cidadão",
    descricao: "O perfil base para todos os usuários da plataforma.",
    icone: "icon-cidadao",
    criterios: ["CPF autenticado no Gov.PI Cidadão ou Gov Br."],
  },
  {
    perfil: "servidor-publico",
    nome: "Perfil do Servidor Público Estadual",
    descricao:
      "Para agentes públicos com vínculo ativo na administração estadual.",
    icone: "icon-servidor-publico",
    criterios: [
      "Matrícula funcional válida (identificador único).",
      "CPF vinculado ativo com órgão da administração pública estadual.",
    ],
  },
  {
    perfil: "pessoa-idosa",
    nome: "Perfil da Pessoa Idosa",
    descricao: "Perfil especial com serviços direcionados a cidadãos idosos.",
    icone: "icon-pessoa-idosa",
    criterios: [
      "Idade igual ou superior a 60 anos (conforme o Estatuto do Idoso).",
      "Registro de prova de vida atualizado.",
    ],
  },
  {
    perfil: "mulher",
    nome: "Perfil da Mulher",
    descricao: "Perfil especial com serviços direcionados ao público feminino.",
    icone: "icon-mulher",
    criterios: [
      "Sexo feminino registrado na base oficial do CPF/RG ou declarado em bases oficiais.",
    ],
  },
];
